import { useQuery } from "react-query";
import { getSampleInspectionFilters } from "src/sampleInspection/data-access/gateway";

function useGetSampleInspectionFilters(enabled = true) {
  return useQuery({
    queryKey: ["getSampleInspectionFilters"],
    queryFn: () => getSampleInspectionFilters(),
    enabled,
  });
}

export default useGetSampleInspectionFilters;
